import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { isNonEmptyInput } from '~/infra/utils';
export const connectCreditCardTextsPath = 'components.managePaymentMethods';
export function emptyExpiryError(texts) {
    return texts.invalidExpiry();
}
export function emptyCvvError(texts) {
    return texts.invalidCvv();
}
export function emptyCardNumberError(texts) {
    return texts.invalidCardNumber();
}
export const getInitialValueState = ()=>({
        value: '',
        error: null,
        pristine: true,
        touched: false
    });
export const getInitialStripeValue = function getInitialStripeValue() {
    let errorMessage = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
    return {
        touched: false,
        valid: false,
        errorMessage
    };
};
export function mapStripeErrorToMessage(error, texts) {
    switch(error.code){
        case 'card_declined':
            {
                switch(error.decline_code){
                    case 'invalid_account':
                        return texts.connectionFailed();
                    case 'transaction_not_allowed':
                    case 'do_not_honor':
                        return texts.declined();
                    default:
                        return null;
                }
            }
        case 'incorrect_cvc':
        case 'invalid_cvc':
            return texts.incorrectSecurityCode();
        case 'setup_intent_authentication_failure':
            return texts.authenticationFailed();
        case 'incorrect_number':
            return texts.incorrectNumber();
        default:
            return null;
    }
}
export const stripeStateReducer = (state, action)=>{
    const { type, errorMessage = '' } = action;
    switch(type){
        case 'error':
            return _object_spread_props(_object_spread({}, state), {
                valid: false,
                errorMessage
            });
        case 'valid':
            return state.valid ? state : _object_spread_props(_object_spread({}, state), {
                valid: true
            });
        case 'blur':
            return state.touched ? state : _object_spread_props(_object_spread({}, state), {
                touched: true
            });
        default:
            return state;
    }
};
export function validateNameOnCard(value, texts) {
    return isNonEmptyInput(value) ? '' : texts.specifyNameOnCard();
}
export function validateZipCode(value, texts) {
    let minLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    const trimmed = value.trim();
    let error = '';
    if (!isNonEmptyInput(trimmed)) {
        error = texts.specifyZipCode();
    } else if (minLength > 0 && trimmed.length < minLength) {
        error = texts.invalidZipCode();
    }
    return error;
}
